module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.computedClass
  }, [_c('select', {
    staticClass: "langselector__select ff-light uppercase",
    on: {
      "change": function($event) {
        _vm.langChanged($event.target);
      }
    }
  }, _vm._l((_vm.langs), function(lang, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": [lang.id, lang.value],
        "selected": _vm.locale === lang.value
      }
    }, [_vm._v("\n            " + _vm._s(lang.label) + "\n        ")])
  }))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-12c7add6","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/langSelector/langSelector.vue
// module id = 3025
// module chunks = 0